<template>
  <div class="close">
    <button class="w-b-btn" @click="$emit('close')" data-shortcut-esc="editorCloseButton">閉じる</button>
  </div>
</template>

<script>
import ShortCutBase from '@/mixins/ShortCutBase'

export default {
  mixins: [
    ShortCutBase
  ]
}
</script>

<style lang="scss" scoped>
.close {
  position: fixed;
  bottom: 20px;
  right: 10px;
}
</style>
